import {
  ChangeDetectionStrategy,
  Component,
  HostBinding,
  Input,
} from '@angular/core';
import {
  ProductListConfiguration,
  ProductListConfigurationKeys,
  ProductListConfigurations,
  PRODUCT_LIST_NAMESPACE,
} from '@epicuro-next/constants/rule-engine/product-list-rules';
import { ConfigurationsService } from '@epicuro-next/platform/configuration';
import {
  patchEpicShowProductInList,
  selectActiveListProductsReference,
} from '@epicuro-next/state/product-list-state';
import { openOverlayOutlet } from '@epicuro-next/state/router-store';
import { isNonNullish } from '@epicuro-next/utilities';
import { select, Store } from '@ngrx/store';
import { Product } from 'graphql-api/gql-api-interfaces';
import { ProductReference } from '@epicuro-next/models/engagement';
import { shareReplay } from 'rxjs/operators';

@Component({
  selector: 'epc-epic-show-product-presentation',
  templateUrl: './epic-show-product-presentation.component.html',
  styleUrls: ['./epic-show-product-presentation.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class EpicShowProductPresentationComponent {
  @Input()
  public products: Product[];

  @HostBinding('class')
  public get getClassList() {
    let list = '';
    if (this.products && this.products.length > 0) list += 'has-items';
    return list;
  }

  public productTitleFields$ = this.configsService.getConfigValue<
    ProductListConfigurations,
    ProductListConfigurationKeys.ProductTitleFormat
  >({
    namespace: PRODUCT_LIST_NAMESPACE,
    featureName: ProductListConfigurationKeys.ProductTitleFormat,
    defaultValue:
      ProductListConfiguration[ProductListConfigurationKeys.ProductTitleFormat],
  });

  public idFields$ = this.configsService.getConfigValue<
    ProductListConfigurations,
    ProductListConfigurationKeys.ProductIdFormat
  >({
    namespace: PRODUCT_LIST_NAMESPACE,
    featureName: ProductListConfigurationKeys.ProductIdFormat,
    defaultValue:
      ProductListConfiguration[ProductListConfigurationKeys.ProductIdFormat],
  });

  public activeListProductReferences$ = this.store.pipe(
    select(selectActiveListProductsReference),
    shareReplay({ bufferSize: 1, refCount: true }),
  );

  constructor(
    private configsService: ConfigurationsService,
    private store: Store,
  ) {}

  public onAddToListClicked(product: Product) {
    this.store.dispatch(patchEpicShowProductInList({ product }));
  }

  public onOpenCSTripClicked(product: Product) {
    const ids: string[] = [
      product.parent?.productId,
      product.productId,
      product.productId,
    ]
      .filter(isNonNullish)
      .slice(0, 2);

    const overlayPath = ['cs', product.brandId, ...ids];

    this.store.dispatch(openOverlayOutlet({ overlayPath }));
  }

  public isProductInActiveList(
    references: ProductReference[] | null,
    product: Product,
  ): boolean {
    return isNonNullish(
      (references ?? []).find(
        ({ productId, brandId }) =>
          productId === product.productId && brandId === product.brandId,
      ),
    );
  }
}
